/**
 * Loads Google Analytics 4 (gtag.js) on the client. GA4 is the hub: the
 * `purchase` event fired from checkout (see `useAnalytics`) is imported into
 * Google Ads as the conversion, with Enhanced ("Optimized") Conversions via the
 * hashed `user_data` we set before the purchase. Cookies (`_ga`, `_gcl_aw`)
 * default to the registrable parent domain, so the session + gclid are shared
 * with the marketing site (`masterdaweb.com`) — no cross-domain linker needed.
 *
 * Complete no-op (no script injected) when `gaMeasurementId` is empty.
 */
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export default defineNuxtPlugin(() => {
  const measurementId = useRuntimeConfig().public.gaMeasurementId as string;
  if (!measurementId) return;

  // gtag bootstrap (mirrors Google's official snippet).
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // GA4 auto page_view also covers SPA route changes.
  window.gtag('config', measurementId, { send_page_view: true });

  // Inject the gtag.js library once.
  const src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  if (!document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }
});
